export { default as BurningIcon } from './BurningIcon';
